import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { IterableEmail } from 'ui/logo/IterableEmail';
import { IterableSms } from 'ui/logo/IterableSms';
import {
  SENDING_PLATFORMS_METADATA,
  ITERABLE,
  ITERABLE_SMS,
  MAILGUN,
  DYN,
  SENDGRID,
  SPARKPOST,
  TELNYX,
  TWILIO,
  CUSTOM_EMAIL,
  CUSTOM_PUSH,
  SendingPlatform,
  WHATS_APP,
} from '../constants';

const ITERABLE_SMS_METADATA_OVERRIDES = {
  [ITERABLE]: {
    name: 'Iterable Email',
    logoSvg: IterableEmail,
  },
  [ITERABLE_SMS]: {
    logoSvg: IterableSms,
  },
  [MAILGUN]: {},
  [DYN]: {},
  [SENDGRID]: {},
  [SPARKPOST]: {},
  [TELNYX]: {
    name: 'Telnyx Direct',
  },
  [TWILIO]: {
    name: 'Twilio Direct',
  },
  [CUSTOM_EMAIL]: {},
  [CUSTOM_PUSH]: {},
  [WHATS_APP]: {},
};

export const useMetadata = (sendingPlatform: SendingPlatform) => {
  const { SendingPlatformsIterableSMSUI } = useSelector(selectFeatureFlags);

  const metadata = SendingPlatformsIterableSMSUI
    ? {
        ...SENDING_PLATFORMS_METADATA[sendingPlatform],
        ...ITERABLE_SMS_METADATA_OVERRIDES[sendingPlatform],
      }
    : SENDING_PLATFORMS_METADATA[sendingPlatform];

  return metadata;
};
